var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "quick-view-list",
      class: { show: _vm.item },
      attrs: {
        "data-epica-module-name": "Contenido Lista",
        "data-mrf-recirculation": "Contenido Lista",
      },
    },
    [
      _vm.item
        ? _c("div", { staticClass: "grid-y content-quick-view" }, [
            _c("div", { staticClass: "header-quick-view" }, [
              _c("div", { staticClass: "ctrlsList d-flex" }, [
                _c(
                  "button",
                  {
                    staticClass: "arrow-list",
                    class: { h: _vm.p },
                    attrs: { type: "button" },
                    on: { click: _vm.prev },
                  },
                  [_c("i", { staticClass: "icon-arrow_back" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "arrow-list",
                    class: { h: _vm.n },
                    attrs: { type: "button" },
                    on: { click: _vm.next },
                  },
                  [_c("i", { staticClass: "icon-arrow_forward" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grow" }),
                _vm._v(" "),
                _c("div", { staticClass: "flex-grow-1" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_c("i", { staticClass: "icon-close" })]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col auto" }, [
              _c("img", {
                attrs: { src: _vm.item.image.url, alt: _vm.item.image.alt },
              }),
              _vm._v(" "),
              _c("h3", {
                staticClass: "kicker",
                domProps: { innerHTML: _vm._s(_vm.item.header) },
              }),
              _vm._v(" "),
              _c("h2", { domProps: { innerHTML: _vm._s(_vm.item.title) } }),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.item.content) } }),
            ]),
            _vm._v(" "),
            _vm.item.url
              ? _c("div", { staticClass: "content-button" }, [
                  _c(
                    "a",
                    { staticClass: "bt", attrs: { href: _vm.item.url } },
                    [_vm._v("VER MÁS CONTENIDO")]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "opacity-menu",
        class: { show: _vm.item },
        on: { click: _vm.close },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }